import styled from 'styled-components';

const HeaderStyle = styled.header`
	--headerPadTB: var(--sp3x);
	--headerPadLR: var(--sp6x);
	--switcherBtnDistance: var(--sp6x);

	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	/* will-change: transform; */
	transform: translateY(-100%);
	padding: var(--headerPadTB) var(--headerPadLR);
	/* transition: background-color var(--trTime) ease-out; */
	z-index: 7;

	/* mix-blend-mode: hard-light; */
	/* isolation: isolate; */

	.header-inner-wrapper {
		display: grid;
		grid-template-columns: 1fr auto 1fr;
		gap: var(--sp2x);
	}

	.right-block {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: var(--switcherBtnDistance);
	}

	.burger-open-close {
		z-index: 11;
	}

	&.default-background {
		background-color: var(--lightGray1000);

		* {
			color: var(--green1000);
			fill: var(--green1000);
		}

		.menu-bar-item {
			&:before {
				background-color: var(--green1000);
			}
		}

		.right-block {
			.btn {
				a,
				button {
					border-color: var(--green1000);
					color: var(--green1000);
				}
			}
		}

		.burger-open-close {
			color: var(--green1000);
		}
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--headerPadLR: var(--sp5x);
		--switcherBtnDistance: var(--sp5x);
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--headerPadTB: var(--sp2x);
		--switcherBtnDistance: var(--sp4x);
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--headerPadLR: var(--sp4x);
		--switcherBtnDistance: var(--sp3x);
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--headerPadTB: var(--sp1-5x);
		--switcherBtnDistance: var(--sp4x);
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--switcherBtnDistance: var(--sp2x);
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--headerPadLR: var(--sp3x);

		.header-inner-wrapper {
			grid-template-columns: 1fr 1fr;
		}

		.menu-bar-container {
			display: none;
			pointer-events: none;
		}

		.burger-version {
			display: flex;
			pointer-events: all;
			width: 100%;
			height: calc(100dvh - 100%);
			position: absolute;
			left: 0;
			top: 100%;

			.menu-bar-inner-container {
				display: flex;
				flex-direction: column;
				justify-content: flex-end;
				flex: 1;
				/* gap: var(--sp7x); */
				gap: var(--sp5x);
			}

			.menu-bar-block {
				align-items: flex-start;
				flex-direction: column;
			}

			.menu-bar-item {
				font-size: var(--h2);
			}
		}

		.shape-burger-wrapper {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100dvh;
			overflow: hidden;
			pointer-events: none;

			&::before {
				content: '';
				background-color: var(--yellow1000);
				position: absolute;
				top: 0;
				left: 0;
				width: 800vw;
				height: 400vh;
				transform: translate(20%, -37%);
				border-top-left-radius: 50%;
				border-bottom-left-radius: 50%;
				transition: transform 0.7s ease-out;
				z-index: 5;
			}
		}

		&.burger-shape {
			.burger-open-close,
			.menu-bar-item-link {
				opacity: 0;
			}

			.burger-menu-btn {
				transform: scale(0);
			}

			.shape-burger-wrapper {
				&::before {
					transform: translate(-5%, -37%);
				}
			}
		}
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--headerPadTB: var(--sp1-5x);
		--headerPadLR: var(--sp2x);
		--switcherBtnDistance: var(--sp3x);
	}
`;

export default HeaderStyle;
